// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

// Mounted panes keep their history-hydrated runtime when focus moves away.
const readers = new Map<string, number>();

export function retainSessionPane(projectId: string) {
  readers.set(projectId, (readers.get(projectId) ?? 0) + 1);
  return () => {
    const remaining = (readers.get(projectId) ?? 1) - 1;
    if (remaining) readers.set(projectId, remaining);
    else readers.delete(projectId);
  };
}

export function hasSessionPane(projectId: string) {
  return readers.has(projectId);
}
